import { useMutation } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'

export const qualifyService = async ({
  tutor_marking_id,
}: {
  tutor_marking_id: string
}) => {
  return axiosInstance.post(`/mark/qualified/${tutor_marking_id}`)
}

export const useQualifyMark = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['qualifyMark'],
    mutationFn: qualifyService,
  })

  return { qualifyMarkAsync: mutateAsync, isQualifyingMark: isPending }
}
